export interface LendExtendRequestCollection {
  // 資料ID
  id: number
  extendDueDate: string
  revision: number
}

export function LendExtendRequestCollectionToJSON(
  value: LendExtendRequestCollection
): any {
  return {
    id: value.id,
    extend_due_date: value.extendDueDate,
    revision: value.revision
  }
}
